import { apiRequest } from "./apiRequest";

export const downloadNewCompetitorCSVTemplate = async (id: number) => {
  try {
    const blob = await apiRequest<Blob>(
      "get",
      `/export-csv/csv-template-for-competitors/${id}`,
      {
        responseType: "blob",
      },
    );

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${id}.csv`;
    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("CSV download failed", error);
  }
};
